import styled from 'styled-components'

const GoldText = styled.span`
  background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`

export default GoldText
